import React, { useState } from "react";
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import Subjects from "./Subject";
import Courses from "./Course";
import Classes from "./Class";
import Footer from "components/Footers/Footer";

const Academics = () => {

  const [activeTab, setActiveTab] = useState("subjects");
  const [subjectModalOpen, setSubjectModalOpen] = useState(false);
  const [courseModalOpen, setCourseModalOpen] = useState(false);
  const [classModalOpen, setClassModalOpen] = useState(false);

  const toggleSubjectModal = () => {
    setSubjectModalOpen(!subjectModalOpen);
  };

  const toggleCourseModal = () => {
    setCourseModalOpen(!courseModalOpen);
  };

  const toggleClassModal = () => {
    setClassModalOpen(!classModalOpen);
  };

  const tabs = ["subjects", "courses", "class"];

  return (
    <>
      <div
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "600px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        <span className="mask bg-gradient-default opacity-8" />
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="12" md="10">
              <h1 className="display-2 text-white">Academics Management</h1>
              <p className="text-white mt-0 mb-5">
                Manage your academic resources and information efficiently.
              </p>
              <div className="border-0 px-0 px-md-3 d-flex align-items-center justify-content-between">
                {tabs && tabs.map((tab) => (
                  <Button
                    key={tab}
                    color={activeTab === tab ? "info" : "secondary"}
                    onClick={() => setActiveTab(tab)}
                    className={tab === "grade-promotion" ? "w-auto" : ""}
                  >
                    {tab === "grade-promotion"
                      ? "Promotion Rule"
                      : tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>

        </Container>
      </div>

      <Container className="mt--7" fluid>
        {activeTab === "subjects" && (
          <Subjects toggleSubjectModal={toggleSubjectModal} />
        )}
        {activeTab === "courses" && (
          <Courses toggleCourseModal={toggleCourseModal} />
        )}
        {activeTab === "class" && (
          <Classes toggleClassModal={toggleClassModal} />
        )}
      </Container>
      <Footer />
    </>
  );
};

export default Academics;
